import { getIntegrationLotById } from '@/http/lot/integration'

export class IntegrationService {
  async getLot(id) {
    const { data } = await getIntegrationLotById(id)
    return data
  }
}
